<template>
  <div class="charts">
    <r-main-panel :title="`${$t('charts:title')}`">
      <div class="charts-options">
        <div class="charts-options__wrapper">
          <div class="charts-options-block">
            <chartsNav />
          </div>
          <div class="charts-options-block">
            <el-tabs
              :stretch="true"
              class="r-tabs"
              v-model="activeTab"
              v-if="isReady"
            >
              <el-tab-pane name="settings">
                <span slot="label" class="r-tabs__title">
                  <r-icon
                    name="settings"
                    :size="14"
                    type="additional"
                    :color-type="
                      activeTab === 'settings' ? 'accent-primary' : ''
                    "
                  />
                  <r-text
                    :color-type="
                      activeTab === 'settings' ? 'accent-primary' : ''
                    "
                    style="margin-left:2px"
                  >
                    {{ $t("charts:ds-select") }}
                  </r-text>
                </span>
                <chartsBook v-show="isReady" />
              </el-tab-pane>
              <el-tab-pane name="stylize" v-if="hasStyle">
                <span slot="label" class="r-tabs__title">
                  <r-icon
                    name="stylize"
                    :size="14"
                    type="additional"
                    :color-type="
                      activeTab === 'stylize' ? 'accent-primary' : ''
                    "
                  />
                  <r-text
                    :color-type="
                      activeTab === 'stylize' ? 'accent-primary' : ''
                    "
                    style="margin-left:2px"
                  >
                    {{ $t("charts:style-settings") }}
                  </r-text>
                </span>
                <chartsStyles v-show="isReady" />
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
    </r-main-panel>
    <div class="charts-content" v-loading="isLoading" @click="deactivateCharts">
      <chartsContent />
    </div>
  </div>
</template>

<script>
import chartsContent from "./components/charts-content.vue";
import chartsNav from "./components/options/charts-nav.vue";
import chartsBook from "./components/options/charts-book.vue";
import chartsStyles from "./components/options/charts-styles.vue";
import variables from "@/styles/variables.scss";

export default {
  components: {
    chartsContent,
    chartsNav,
    chartsBook,
    chartsStyles
  },
  data() {
    return {
      activeTab: "settings",
      isLoading: false,
      isReady: false,
      primaryColor: variables.primaryColor
    };
  },
  watch: {
    "$store.state.charts.activeChart": {
      handler: function(value) {
        let charts = Object.keys(value);
        if (charts.length && charts[0] !== "updated") {
          this.isReady = true;
        } else {
          this.isReady = false;
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    hasStyle() {
      return this.$store.getters.hasInstrument("Chart", "Styles");
    }
  },
  methods: {
    deactivateCharts(value) {
      const hasActive = Object.keys(this.$store.state.charts.activeChart)
        .length;
      const targetName = value.target.className;
      if (hasActive) {
        switch (targetName) {
          case "el-tabs__content":
          case "vue-grid-layout":
          case "charts-content":
            this.$store.commit("DEACTIVATE_CHARTS");
            break;
        }
      }
    }
  }
};
</script>

<style lang="scss">
.charts {
  display: flex;
  width: 100%;
  height: 100%;
  position: relative;
  .charts-options__wrapper {
    padding: 8px;
    height: calc(100% - 16px);
    width: calc(100% - 16px);
    overflow: hidden;
  }
  .charts-icon {
    width: 20px;
    height: 20px;
    margin-right: 14px;
    margin-top: 3px;
  }
  .charts-options {
    position: relative;
    overflow: hidden;
    height: 100%;
    &-block {
      position: relative;
      max-height: calc(100% - 121px);
      overflow: hidden;
      overflow-y: auto;
      margin-bottom: 16px;
      &:last-child {
        padding-bottom: 20px;
        margin-bottom: 0;
      }
    }
  }
  .charts-content {
    width: calc(100% - 260px);
    height: calc(100% - 60px);
    overflow: hidden;
    padding-bottom: 60px;
    position: relative;
    background-color: var(--bg_surface) !important;
  }
}
</style>

<i18n>
{
  "ru": {
    "charts:title": "Графики",
    "charts:ds-select": "Данные",
    "charts:style-settings": "Внешний вид"
  },
  "en": {
    "charts:title": "Charts",
    "charts:ds-select": "Data",
    "charts:style-settings": "Stylization"
  }
}
</i18n>
